import { Component } from 'preact';

import TemperatureSummary from '../live/temperature-summary';
import WindSummary from '../live/wind-summary';
import RainSummary from '../live/rain-summary';
import { extractRainSummaryData, extractTemperatureSummaryData, extractWindSummaryData } from '../../utils/live-data';
import style from './style.scss';
import handleLoadingAndError from '../handle-loading-and-error';
import {
	formatPressure,
	formatRainfall, formatRainRate,
	formatTemperature,
	formatTemperatureInterval, formatWindGust, formatWindSpeed,
	getDateTimeFormatConverter
} from '../../utils/formatters';

/**
 * The LivePanel component is responsible for displaying the main panel on the
 * live page, where all the current live data is shown.
 *
 * props:
 * - data: full live data object from the api
 */
class LivePanel extends Component {

	constructor(props, context) {
		super(props, context);

		this.units = context.userSettings.units;

		this.formatters = {
			time: getDateTimeFormatConverter('%H:%M', '%X'),
			temperature: t => formatTemperature(t, this.units.temperature),
			temperatureTrend: t => formatTemperatureInterval(t, this.units.temperature),
			rainfall: t => formatRainfall(t, this.units.rain),
			rainRate: t => formatRainRate(t, this.units.rain),
			pressure: t => formatPressure(t, this.units.pressure),
			windSpeed: t => formatWindSpeed(t, this.units.speed),
			windGust: t => formatWindGust(t, this.units.speed)
		};
	}

	render(props) {

		const temperatureData = extractTemperatureSummaryData(props.data);
		const windData = extractWindSummaryData(props.data);
		const rainData = extractRainSummaryData(props.data);

		return (
			<div class={style.primary_layout}>

				<div class={style.primary_box}>
					<TemperatureSummary data={temperatureData}
					                    temperatureFormatter={this.formatters.temperature}
					                    temperatureTrendFormatter={this.formatters.temperatureTrend}
					                    timeFormatter={this.formatters.time}
					                    temperatureUnit={this.units.temperature} />
				</div>

				<div class={style.primary_box}>
					<WindSummary data={windData}
					             windSpeedFormatter={this.formatters.windSpeed}
					             windGustFormatter={this.formatters.windGust}
					             timeFormatter={this.formatters.time}
					             speedUnit={this.units.speed} />
				</div>

				<div class={style.primary_box}>
					<RainSummary data={rainData}
					             rainFormatter={this.formatters.rainfall}
					             rainRateFormatter={this.formatters.rainRate}
					             pressureFormatter={this.formatters.pressure}
					             rainUnit={this.units.rain}
					             pressureUnit={this.units.pressure} />
				</div>

			</div>
		);

	}

};

export default handleLoadingAndError(LivePanel);



// WEBPACK FOOTER //
// ./components/live-panel/index.js